import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Features = () => {
  const benefits = [
    { title: "Expert Instruction", desc: "Every program created by industry practitioners with real-world track records.", icon: FiIcons.FiAward },
    { title: "Digital Certification", desc: "Get a verified certificate for every course completion to build your authority.", icon: FiIcons.FiCheckCircle },
    { title: "Elite Community", desc: "Private access to a high-level network of learners & entrepreneurs.", icon: FiIcons.FiUsers },
    { title: "Weekly Live Coaching", desc: "Direct access to mentors to solve your specific technical hurdles every week.", icon: FiIcons.FiRadio }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 py-12 border-y border-slate-900 mb-20 bg-slate-950/50">
      {benefits.map((b, i) => (
        <div key={i} className="flex gap-4 p-4">
          <div className="flex-shrink-0 w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center text-amber-500">
            <SafeIcon icon={b.icon} className="text-xl" />
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-1">{b.title}</h4>
            <p className="text-slate-500 text-xs leading-relaxed">{b.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Features;